import { render, staticRenderFns } from "./shopChessCatalog.vue?vue&type=template&id=f87fc668&"
import script from "./shopChessCatalog.vue?vue&type=script&lang=js&"
export * from "./shopChessCatalog.vue?vue&type=script&lang=js&"
import style0 from "./shopChessCatalog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports